var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "header-logo" }, [
        _c("img", {
          attrs: {
            src: _vm.model.headerLogoSource,
            alt: _vm.model.headerLogoImgAlt
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "utility-actions" },
        [
          _vm.model.authenticated
            ? _c(
                "router-link",
                {
                  staticClass: "utility-link utility-link--no-decoration",
                  attrs: {
                    to: { name: "logout" },
                    "data-test-element": "logout-link"
                  }
                },
                [_vm._v("logout")]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1890f162", { render: render, staticRenderFns: staticRenderFns })
  }
}